module.exports = __webpack_public_path__ + "static/media/galdinsLose_50_75.f59a3e92.png";